import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { BaseModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

export interface ContentPageModel extends BaseModel {
    id: string;
    description: string;
    link: string;
    name: string;
    pageType: string;
    summary: string | null;
    thumbnail: string | null;
    publishDate: string | null;
}

export interface SortOption {
    displayName: string;
    sortType: string;
}

export interface ContentSearchCollectionModel extends BaseModel {
    pages: ContentPageModel[];
    pagination: PaginationModel;
    pageTypeFacets: any[];
}

export interface GetContentSearchApiParameter extends ApiParameter, HasPagingParameters {
    query?: string;
}

const contentSearchUrl = "/api/v2/contentsearch";

export function getContentSearch(parameter: GetContentSearchApiParameter) {
    return get<ContentSearchCollectionModel>(contentSearchUrl, parameter);
}
